<template>

  <Modal v-if="visible" :value="true" @input="closeModal">
    <span slot="header">{{ title }}</span>

    <div class="row text-align-center">
      <div class="col-md-12">
        <p>Deseja realmente excluir o veículo com placa <strong>{{ vehicle.plate }}</strong></p>
        <button class="btn btn-outline-red btn-md mr-2" @click="$emit('sendDeleteModel', vehicle)">Excluir</button>
        <button class="btn btn-outline btn-md" @click="closeModal">Cancelar</button>
      </div>
    </div>
  </Modal>

</template>

<script>
  import Modal from '../shares/specialTag/Modal'

  export default {
    components: { Modal },
    computed: {
      visible() {
        return this.vehicle && this.value
      }
    },
    methods: {
      closeModal() { this.$emit('input', false) }
    },
    name: 'ModalDeleteCompany',
    props: {
      title: { default: 'Excluir veículo', type: String },
      value: { default: false, type: Boolean },
      vehicle: { type: Object },
    }
  }
</script>

<style scoped>

</style>
